import { trigger, transition, style, animate } from '@angular/animations';

/**
 * Animation for dropdown expand/collapse with smooth height transition.
 * Similar to growAnimation but optimized for dropdown children container behavior.
 */
export const dropdownAnimation = trigger('dropdownAnimation', [
  transition(':enter', [
    style({
      height: '0px',
      opacity: 0,
      overflow: 'hidden'
    }),
    animate('250ms ease-out', style({
      height: '*',
      opacity: 1
    }))
  ]),
  transition(':leave', [
    animate('250ms ease-in', style({
      height: '0px',
      opacity: 0
    }))
  ])
]);

